import {
  PAGE1_MAINTITLE,
  PAGE1_SUBTITLE,
  PAGE1_ADDR,
  PAGE1_TIME
} from "./action.index";

import {
  PAGE2_TITLE,
  PAGE2_CONTENT1,
  PAGE2_RIGHTS,
  PAGE2_BANNER_IMAGES
} from "./action.condition";

import { PAGE3_ABOUT, PAGE3_BANNER_IMAGES } from "./action.about";

import {
  TEMP_PAGE_DATA,
  TEMP_PAGE_MODE,
  TEMP_PAGE_BRAND,
  GLOBAL_ACTION_EDIT
} from "./action";

export const contextReducer = (state, action) => {
  let curState = null;
  console.info("state change:", action);
  switch (action.type) {
    case GLOBAL_ACTION_EDIT:
      curState = JSON.parse(JSON.stringify(state));
      curState.editing = action.editing;
      if (action.editing) {
        curState.extra = action.extra;
      }
      break;
    case TEMP_PAGE_BRAND:
      curState = JSON.parse(JSON.stringify(state));
      curState.noBrand = !!action.noBrand;
      break;
    case TEMP_PAGE_DATA:
      curState = JSON.parse(JSON.stringify(state));
      curState = { ...curState, ...action.data };
      window.edit_mode = curState && curState.tempMode === "edit";
      break;
    case TEMP_PAGE_MODE:
      curState = JSON.parse(JSON.stringify(state));
      curState.tempMode = action.mode;
      window.edit_mode = curState && curState.tempMode === "edit";
      break;
    case PAGE1_MAINTITLE:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[0][0].content = action.content;
      break;
    case PAGE1_TIME:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[0][1].content = action.content;
      break;
    case PAGE1_ADDR:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[0][2].content = action.content;
      break;
    case PAGE1_SUBTITLE:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[0][3].content = action.content;
      break;

    case PAGE2_TITLE:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[1][1].content = action.content;
      break;
    case PAGE2_BANNER_IMAGES:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[1][0] = action.photoinfo;
      break;

    case PAGE2_CONTENT1:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[1][2].content = action.content;
      break;

    case PAGE2_RIGHTS:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[1][3].content = action.content;
      break;

    case PAGE3_ABOUT:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[2][1].content = action.content;
      break;

    case PAGE3_BANNER_IMAGES:
      curState = JSON.parse(JSON.stringify(state));
      curState.pages[2][0] = action.photoinfo;
      break;
    default:
      curState = state;
      break;
  }
  return curState;
};
